import React from "react";
import { twMerge } from "tailwind-merge";
import { CMSData } from "@/cms/models";
import TextField from "@mui/material/TextField";

interface TextAreaInputProps {
  required: boolean;
  label: string;
  defaultValue: string;
  errors: string[] | undefined;
  name: string;
  className?: string;
  cmsData: CMSData;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({
  required,
  label,
  defaultValue,
  errors,
  name,
  className = "",
  cmsData,
}) => {
  const style = cmsData.forms.style;

  const renderTextArea = (variant: any) => (
    <TextField
      multiline
      className={twMerge("flex col-span-6 flex-col", className)}
      label={label}
      size={style?.size}
      variant={variant}
      name={name}
      defaultValue={defaultValue}
      required={required}
      error={!!errors}
    />
  );

  switch (style?.type) {
    case "material-outlined":
      return renderTextArea("outlined");
    case "material-standard":
      return renderTextArea("standard");
    default:
      return renderTextArea("filled");
  }
};

export default TextAreaInput;
